import { IndicatorFactType } from '@/api/rest/resources/types/fact';
import { useIndicatorProduct } from '@/hooks/useIndicatorProduct';

export const useIsFactInPurchasedIndicatorProducts = (factType: IndicatorFactType): boolean => {
  const purchasedIndicatorProducts =
    useIndicatorProduct({
      purchased: true,
      visible_for_customer: true,
    }).data ?? [];

  return !!purchasedIndicatorProducts.some((ip) => ip.indicator_names.some((name) => [factType].includes(name)));
};
